import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'

interface TextoSegmento {
  tipo: 'texto' | 'campo'
  valor: string // texto estático ou nome do campo
}

@Component({
  selector: 'app-texto-com-placeholders',
  template: `
    <div class="texto-introdutorio">
      <ng-container *ngFor="let seg of segmentos">
        <span *ngIf="seg.tipo === 'texto'">{{ seg.valor }}</span>
        <span *ngIf="seg.tipo === 'campo' && !isSelect(seg.valor)" class="inline-input-wrapper">
          <input class="inline-input"
            [placeholder]="labelPara(seg.valor)"
            [(ngModel)]="campos[seg.valor]"
            [mask]="isData(seg.valor) ? '00/00/0000' : ''"
            [dropSpecialCharacters]="false"
            [attr.aria-label]="labelPara(seg.valor)"
            (ngModelChange)="onFieldChange(seg.valor)">
        </span>
        <span *ngIf="seg.tipo === 'campo' && isSelect(seg.valor)" class="inline-input-wrapper">
          <select class="inline-select"
            [value]="campos[seg.valor] || ''"
            [attr.aria-label]="labelPara(seg.valor)"
            (change)="onSelectChange(seg.valor, $any($event.target).value)">
            <option value="" disabled>{{ labelPara(seg.valor) }}</option>
            <option *ngFor="let opt of opcoesPara(seg.valor)" [value]="opt">{{ opt }}</option>
          </select>
        </span>
      </ng-container>
    </div>
  `,
  styles: [`
    .texto-introdutorio {
      line-height: 1.6;
      font-size: 14px;
      font-family: Verdana, Arial, sans-serif;
      text-align: justify;
      margin-top: 0.5em;
    }
    .inline-input-wrapper {
      display: inline-block;
      vertical-align: baseline;
      margin: 0 2px;
    }
    .inline-input, .inline-select {
      font-size: 14px;
      font-family: inherit;
      border: none;
      border-bottom: 1.5px solid #1976d2;
      background: transparent;
      padding: 2px 4px;
      min-width: 100px;
      outline: none;
      color: inherit;
      line-height: 1.8;
      text-align: center;
    }
    .inline-input:focus, .inline-select:focus {
      border-bottom-color: #0d47a1;
      background: rgba(25, 118, 210, 0.04);
    }
    .inline-input::placeholder {
      color: #90a4ae;
      font-size: 12px;
      text-align: center;
    }
    .inline-select {
      cursor: pointer;
      min-width: 110px;
    }
  `]
})
export class TextoComPlaceholdersComponent implements OnChanges {
  @Input() texto = ''
  @Input() campos: Record<string, string> = {}
  @Output() camposChange = new EventEmitter<Record<string, string>>()

  segmentos: TextoSegmento[] = []

  private readonly labels: Record<string, string> = {
    dataDoe: 'Data DOE',
    dataDivulgacao: 'Data Divulgação',
    dataInicio: 'Data Início',
    dataFim: 'Data Fim',
    tipoEdital: 'Tipo',
    dataDocumento: 'Data',
    dataHoraReuniao: 'Data e hora da reunião',
    dataRealizacaoProva: 'Data da prova',
    deliberacaoCepe: 'nº/ano',
    prazoAnalise: 'Prazo (dias)',
    localProva: 'Local da prova',
  }

  private readonly selects: Record<string, string[]> = {
    tipoEdital: ['Abertura', 'Calendário de Provas'],
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['texto']) {
      this.parsear()
    }
  }

  private parsear(): void {
    this.segmentos = []
    const regex = /\{\{(\w+)\}\}/g
    let ultimo = 0
    let match: RegExpExecArray | null

    while ((match = regex.exec(this.texto)) !== null) {
      if (match.index > ultimo) {
        this.segmentos.push({ tipo: 'texto', valor: this.texto.substring(ultimo, match.index) })
      }
      this.segmentos.push({ tipo: 'campo', valor: match[1] })
      ultimo = regex.lastIndex
    }

    if (ultimo < this.texto.length) {
      this.segmentos.push({ tipo: 'texto', valor: this.texto.substring(ultimo) })
    }
  }

  isSelect(campo: string): boolean {
    return campo in this.selects
  }

  isData(campo: string): boolean {
    return campo.startsWith('data') || campo.startsWith('Data')
  }

  opcoesPara(campo: string): string[] {
    return this.selects[campo] || []
  }

  labelPara(campo: string): string {
    return this.labels[campo] || campo
  }

  onFieldChange(campo: string): void {
    this.camposChange.emit({ ...this.campos })
  }

  onSelectChange(campo: string, valor: string): void {
    this.campos[campo] = valor
    this.camposChange.emit({ ...this.campos })
  }
}
